import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useState,useEffect } from 'react'
import barcodeServices from '../services/barcodeServices';

function PrintBarcode({batchId}) {

    const [barcodeList,setBarcodeList] = useState(null);
    const getBarcodeList = () => {
        if(batchId !== null){
            barcodeServices.getByBatchId(batchId).then(res=>{
                setBarcodeList(res.data);
            }).catch(error=>{
    
            })
        }        
    }
    useEffect(()=>{
        getBarcodeList();
    },[batchId])

    return (
        barcodeList && 
        <div>
            <Dialog
                open={true}
                keepMounted
                onClose={()=>setBarcodeList(null)}
                maxWidth="sm"
            >
                <DialogTitle>Batch Id : {barcodeList.batchDetails.id} - ({barcodeList.data.length} / {barcodeList.batchDetails.total})  </DialogTitle>
                <DialogContent>
                    <div className='row mt-2'>
                        {barcodeList.data.map(barcode=>
                            <div  key={barcode.id} className='col-md-6'>
                                <span className='barcode'>*{barcode.id}*</span>
                            </div>
                        )}
                    </div>
                </DialogContent>
                
                <DialogActions>
                    <button className="btn btn-outline-primary" >Print</button>
                </DialogActions>
            </Dialog>
        </div>
        
    )
}

export default PrintBarcode